// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */

.render-lead .react-form-builder-form {
    display: block;
  }
  
  .render-lead .rfb-item {
    margin-bottom: 1rem;
  }
  
  .render-lead .form-group {
    margin-bottom: 1rem;
  }
  
  .render-lead .form-label {
    display: flex;
  }
  
  .render-lead .form-control {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid var(--color-border-light2);
    border-radius: 4px;
  }
  
  .render-lead .btn-toolbar {
    margin-top: 1rem;
  }

  .render-lead .custom-control-label{
    margin-left: 1rem;
  }

  .render-lead .validation-error{
    background: rgba(244, 82, 82, 0.2);
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    border-radius: 10px;
    margin-bottom: 10px;
  }

  .render-lead .label-required{
    color: var(--color-error-alt);
     font-size: 26px;
     margin-bottom: 0px;
     position: relative;
     bottom: 6px;
  }

  .render-lead .SortableItem .row{
    display: flex;
    column-gap: 10px;
  }

  
  /* Add any other styles as needed */
  `, "",{"version":3,"sources":["webpack://./src/content/leadGeneration/RenderLeadForm.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;IACI,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,4CAA4C;IAC5C,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;KAC5B,eAAe;KACf,kBAAkB;KAClB,kBAAkB;KAClB,WAAW;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;;EAGA,mCAAmC","sourcesContent":["/* styles.css */\n\n.render-lead .react-form-builder-form {\n    display: block;\n  }\n  \n  .render-lead .rfb-item {\n    margin-bottom: 1rem;\n  }\n  \n  .render-lead .form-group {\n    margin-bottom: 1rem;\n  }\n  \n  .render-lead .form-label {\n    display: flex;\n  }\n  \n  .render-lead .form-control {\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid var(--color-border-light2);\n    border-radius: 4px;\n  }\n  \n  .render-lead .btn-toolbar {\n    margin-top: 1rem;\n  }\n\n  .render-lead .custom-control-label{\n    margin-left: 1rem;\n  }\n\n  .render-lead .validation-error{\n    background: rgba(244, 82, 82, 0.2);\n    padding: 1rem;\n    display: flex;\n    justify-content: space-between;\n    border-radius: 10px;\n    margin-bottom: 10px;\n  }\n\n  .render-lead .label-required{\n    color: var(--color-error-alt);\n     font-size: 26px;\n     margin-bottom: 0px;\n     position: relative;\n     bottom: 6px;\n  }\n\n  .render-lead .SortableItem .row{\n    display: flex;\n    column-gap: 10px;\n  }\n\n  \n  /* Add any other styles as needed */\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
